import React from 'react';
import { AccountDetailsProps } from './types';
import { styles } from './styles';
import AccountField from '../AccountField';

const AccountDetails: React.FC<AccountDetailsProps> = ({ account }) => {
  return (
    <div className={styles.fieldContainer}>
      <AccountField label="Name">
        {account.firstName} {account.lastName}
      </AccountField>
      <AccountField label="Email">{account.email}</AccountField>
      <AccountField label="Role">{account.role}</AccountField>
      {account.partners.length > 0 && (
        <AccountField label="Partners">
          {account.partners.map((partner) => partner.name).join(', ')}
        </AccountField>
      )}
    </div>
  );
};

export default AccountDetails;
